// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oo-1";
export var stateContainer = "_oo-0";